/**
 * 大屏数据刷新配置
 * 统一管理所有组件的定时刷新时间间隔（单位：毫秒）
 */
export const REFRESH_CONFIG = {
  // 环境监测数据刷新间隔（环境数据变化较快，刷新频率较高）
  ENVIRONMENT_MONITOR: 5000, // 5秒 = 5000毫秒

  // 出入态势数据刷新间隔
  ENTRY_STATS: 180000, // 3分钟 = 180000毫秒

  // 资产数据刷新间隔
  ASSETS: 180000, // 3分钟 = 180000毫秒

  // 基础信息数据刷新间隔
  BASIC_INFO: 180000, // 3分钟 = 180000毫秒

  // 地图数据刷新间隔
  MAP_DATA: 180000, // 3分钟 = 180000毫秒

  // 告警数据刷新间隔（告警数据变化较快）
  ALARM: 60000, // 1分钟 = 60000毫秒

  // 视频数据刷新间隔
  VIDEO: 180000, // 3分钟 = 180000毫秒

  // 社区文化数据刷新间隔
  CULTURE: 300000 // 5分钟 = 300000毫秒
}

/**
 * 获取刷新间隔（带单位说明）
 * @param {string} key 配置键名
 * @returns {number} 刷新间隔（毫秒）
 */
export function getRefreshInterval(key) {
  return REFRESH_CONFIG[key] || 180000 // 默认3分钟
}

/**
 * 将毫秒转换为可读的时间描述
 * @param {number} ms 毫秒数
 * @returns {string} 时间描述（如：1分钟、3分钟）
 */
export function formatRefreshInterval(ms) {
  if (ms < 60000) {
    return `${ms / 1000}秒`
  } else if (ms < 3600000) {
    return `${ms / 60000}分钟`
  } else {
    return `${ms / 3600000}小时`
  }
}

